import classNames from "classnames";
import React, { useState } from "react";
import Helpers from "../../../constants/helpers";
import { SubscriptionType, UpsellPanelSteps } from "../../../constants/upsellPanelEnumsAndConstants";
import { useAuth } from "../../../hooks/useAuth";
import { isEurekaDomain, isIntelligentInvestorDomain } from "../../../utils/utils";
import useTrackDocDownloadSF from "../../investWithUs/hooks/useTrackDocDownloadSF";
import useGetDownloadDocUrl from "../hooks/useGetDownloadDocUrl";
import { UpsellWidgetRedirectProvider } from "../hooks/useRedirectContext";
import useReloadFreePopup from "../hooks/useReloadFreePopup";
import { UpsellWidgetContainerProvider } from "../hooks/useUpsellWidgetContainerContext";
import { useUpsellWidgetModel } from "../hooks/useUpsellWidgetModelContext";
import { EmailDisclosure } from "./EmailDisclosure";
import { Step15PopupThankYou } from "./Steps";
import UpSellWidgetContainer from "./UpSellWidgetContainer";

const popOverlaySteps = [
    UpsellPanelSteps.Step1SignUp,
    UpsellPanelSteps.Step2SMSToken,
    UpsellPanelSteps.Step3Login,
    UpsellPanelSteps.Step4MobileUpdate,
    UpsellPanelSteps.Step5UpgradeUser,
    UpsellPanelSteps.Step6Final,
    UpsellPanelSteps.Step7PaymentForm,
    UpsellPanelSteps.Step8ExistingUserLogin,
    UpsellPanelSteps.Step9PreProductActivation,
    UpsellPanelSteps.Step16ForgotPassword,
    UpsellPanelSteps.Step17MFALogin
]
const UpSellWidgetCustomParent = ({ setShowUpsell }) => {
    const model = useUpsellWidgetModel();
    const [currentStep, setCurrentStep] = useState(model.currentStep || 1);
    const [hidePopup, setHidePopup] = useState(false);
    const [baseProps, setBaseProps] = useState({
        user: model.user
    });
    const { isAuthenticated } = useAuth();
    const trackDocDownload = useTrackDocDownloadSF();
    const getDownloadDocUrl = useGetDownloadDocUrl();
    const reloadFreePopup = useReloadFreePopup({ setHidePopup });

    const isERDomain = isEurekaDomain();
    const isIIDomain = isIntelligentInvestorDomain();
    const bgCssClass = isERDomain ? "eureka"
        : isIIDomain ? "ii"
            : "";

    const imgFile = isERDomain ? "ER-left-panel-free.svg"
        : isIIDomain ? "II-pop-up-left-panel.webp"
            : "IS-pop-up-left-panel.webp";

    const updatedImgFile = isAuthenticated && isERDomain ? "ER-left-panel-trial.svg" : imgFile;

    const onCloseBtnClick = (reloadPage = false) => {
        if ((baseProps.refreshOnClose) && !(currentStep === UpsellPanelSteps.Step13EventThankYou || currentStep === UpsellPanelSteps.Step15PopupThankYou)) {
            window.location.reload();
            return;
        }
        if (typeof model.popupMustLogin !== 'undefined' && !model.popupMustLogin) {
            if (reloadPage) {
                window.location.reload();
            }
            else {
                history.replaceState("", document.title, window.location.pathname + window.location.search);
                if (model.productHandle == SubscriptionType.SUBSCRIPTION_INSIGHTS_FREE_PRODUCT_HANDLE) {
                    sessionStorage.setItem("FreeSignUpLastShown", new Date().getTime());
                    reloadFreePopup();
                }
                setHidePopup(true);
                setShowUpsell(false);
                return;
            }
        }
        if (reloadPage === undefined) { // using this to fix ie11 issues since they don't support default parameters.
            reloadPage = true;
        }
        if ((currentStep == UpsellPanelSteps.Step13EventThankYou || currentStep == UpsellPanelSteps.Step15PopupThankYou) && model.downloadFileId) {
            trackDocDownload(model.downloadFileId);
            window.open(getDownloadDocUrl(model.downloadFileId, model.downloadFileUrl), "_blank");
            window.location.reload();
        }
        if (reloadPage && (currentStep == UpsellPanelSteps.Step13EventThankYou || currentStep == UpsellPanelSteps.Step15PopupThankYou)) {
            window.location.reload();
        } else {
            history.replaceState("", document.title, window.location.pathname + window.location.search);
            if (model.productHandle == SubscriptionType.SUBSCRIPTION_INSIGHTS_FREE_PRODUCT_HANDLE) {
                sessionStorage.setItem("FreeSignUpLastShown", new Date().getTime());
                reloadFreePopup();
            }
            setHidePopup(true);
            setShowUpsell(false);
        }
    };

    const goToStep = (stepId) => {
        setCurrentStep(stepId);
    };

    return (
        <UpsellWidgetContainerProvider currentStep={currentStep} goToStep={goToStep} onCloseBtnClick={onCloseBtnClick} setBaseProps={setBaseProps} baseProps={baseProps}>
            <>
                {!hidePopup && (
                    <div className={classNames(
                        "vertical-alignment-wrapper pos-abs-center w-100",
                        {
                            "dialog-wrapper-scrollable":
                                model.productHandle === SubscriptionType.SUBSCRIPTION_TRIAL_PRODUCT,
                        }
                    )}>
                        <div className="modal-signup-background fixed-top"></div>
                        <div className="dialog modal-signup-dialog relative align-middle">
                            <div className={classNames(
                                "dialog-wrapper mx-0 mx-md-auto my-0 popup-overlay-v2",
                                bgCssClass,
                                {
                                    "w-100-sm-down border-rad-0-sm-down bg-white text-color-deep-blue-2 shadow-hover border-rad-8":
                                        currentStep !== UpsellPanelSteps.Step15PopupThankYou,
                                    "dialog-wrapper-scrollable":
                                        model.productHandle === SubscriptionType.SUBSCRIPTION_TRIAL_PRODUCT,
                                }
                            )}
                            >
                                <div className="row mx-0">
                                    {/* Left Panel */}
                                    {popOverlaySteps.includes(currentStep) && (
                                        <div className={classNames(
                                            "col-lg-6 col-12 order-2-sm-down bg-gray-51 text-white info-panel hidden-md-only text-center px-0",
                                            { 'shadow-hover': !model.usePopupOverlay }
                                        )}
                                        >
                                            <img src={Helpers.getBlobFileUrl(`/images/${updatedImgFile}`)} alt="Benefits of membership" title="Benefits of membership" style={{ minHeight: "100%" }} />
                                        </div>
                                    )}

                                    {/* Right Panel */}
                                    {currentStep !== UpsellPanelSteps.Step15PopupThankYou && (
                                        <div className="col-lg-6 col-12 order-1-sm-down px-0-sm-down">
                                            {!model.hideCloseBtn && (
                                                <button type="button" className="btn p-0 popup-overlay close t-r" onClick={() => onCloseBtnClick(false)} >
                                                    <img src={Helpers.getBlobFileUrl("/images/Close.svg")} alt="close" title="close" style={{ width: 40, height: 40 }} />
                                                </button>
                                            )}
                                            <UpsellWidgetRedirectProvider>
                                                <UpSellWidgetContainer />
                                            </UpsellWidgetRedirectProvider>
                                        </div>
                                    )}
                                </div>

                                {currentStep === UpsellPanelSteps.Step15PopupThankYou && <Step15PopupThankYou />}
                            </div>
                        </div>
                    </div>
                )}
                {/* Conditional Rendering */}
                {!model.hideEmailModal && <EmailDisclosure />}
            </>
        </UpsellWidgetContainerProvider >
    );
};

export default UpSellWidgetCustomParent;
